import type { RigKind, RigListQuery } from '@chukua/common';

export type UnitPresetKey = 'all' | 'coupled' | 'no_trailer' | 'spare' | 'deactivated';

/** The Units list's one-click presets; each sets `kind` (and `deactivated`), so a shared link or reload lands on the same list. */
export const UNIT_PRESETS: { key: UnitPresetKey; label: string; kinds: RigKind[]; deactivated?: true }[] = [
  { key: 'all', label: 'All units', kinds: [] },
  { key: 'coupled', label: 'Coupled', kinds: ['coupled'] },
  { key: 'no_trailer', label: 'No trailer', kinds: ['truck_only'] },
  { key: 'spare', label: 'Spare trailers', kinds: ['trailer_only'] },
  { key: 'deactivated', label: 'Deactivated trailers', kinds: [], deactivated: true },
];

/** The preset the URL's `kind` and `deactivated` filters match, or undefined for any other combination. */
export function activeUnitPreset(query: Pick<RigListQuery, 'kind' | 'deactivated'>): UnitPresetKey | undefined {
  const wanted = [...(query.kind ?? [])].sort().join(',');
  return UNIT_PRESETS.find((preset) => [...preset.kinds].sort().join(',') === wanted && Boolean(preset.deactivated) === Boolean(query.deactivated))?.key;
}
